import colors from '../../../theme.json'

export const LIGHT_THEME_COLORS = colors
